import React from 'react';

const AnimatedGradientBackground: React.FC = () => {
  return (
    <div className="animated-gradient-bg" aria-hidden="true">
      <span className="blob blob-1" />
      <span className="blob blob-2" />
      <span className="blob blob-3" />
    </div>
  );
};

export default AnimatedGradientBackground;


